const config = {
  state: {
    transaction : {
      isProceso: false,
      message  : '',
      force    : false
    },
    showProcesos          : true,
    openPopupNotifications: false,
    countAllDownloands    : 0,
    settings              : {
      general : {
        theme : {
          name: 'datacont',
          dark: false
        }
      }
    }
  },
  mutations: {
    SET_SHOW_PROCESOS (state, aux) {
      state.showProcesos = aux
    },
    SET_COUNT_DOWNLOANDS (state, aux) {
      state.countAllDownloands = aux
    },
    SET_SETTINGS (state, aux) {
      state.settings = aux
    },
    SET_OPEN_NOTIFICATIONS (state, aux) {
      state.openPopupNotifications = aux
    },
    SET_SHOW_TRANSACTION (state, aux) {
      if (!state.transaction.force) {
        state.transaction.isProceso = aux.isProceso
        state.transaction.message   = aux.message
      }
    },
    SET_SHOW_TRANSACTION_FORCE (state, aux) {
      state.transaction.isProceso = aux.force
      state.transaction.force     = aux.force
      state.transaction.message   = aux.message
    }
  },
  actions: {
    transaccion ({ commit }, payload) {
      commit('SET_SHOW_TRANSACTION', payload)
    },
    transaccionForce ({ commit }, payload) {
      commit('SET_SHOW_TRANSACTION_FORCE', payload)
    },
    openProcesos ({ commit }) {
      commit('SET_SHOW_PROCESOS', false)
      setTimeout(function () {
        commit('SET_SHOW_PROCESOS', true)
      }, 1)
    },
    closeProcesos ({ commit }) {
      commit('SET_SHOW_PROCESOS', false)
    },
    setOpenPopupNotifications ({ commit }, payload) {
      commit('SET_OPEN_NOTIFICATIONS', payload)
    },
    setCountAllDownloands ({ commit }, payload) {
      commit('SET_COUNT_DOWNLOANDS', payload)
    },
    setSettings ({ commit }, payload) {
      commit('SET_SETTINGS', payload)
    }
  },
  getters : {
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/app.js